import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { z } from 'zod'

const vndlyCandidateIssuesItemSchema = z.object({
  instanceId: z.number(),
  companyId: z.number(),
  workerId: z.number(),
  workerName: z.string(),
  birthMmdd: z.string().nullable(),
  ssnLast4: z.string().nullable(),
  shiftStartsAt: z.string(),
  issues: z.array(z.string()),
})

export type VndlyCandidateIssuesItem = z.infer<
  typeof vndlyCandidateIssuesItemSchema
>

const vndlyCandidateIssuesItemsSchema = z.array(vndlyCandidateIssuesItemSchema)

export type VndlyCandidateIssuesItems = z.infer<
  typeof vndlyCandidateIssuesItemsSchema
>

type ListVndlyCandidateIssuesRequest = {
  page: number
  pageSize: number
  daysAgo?: number | null
  instanceIds?: number[] | null
  companyIds?: number[] | null
}

const listVndlyCandidateIssuesResponseSchema = z.object({
  items: vndlyCandidateIssuesItemsSchema,
  totalRows: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  pageSize: z.number(),
})

export type ListVndlyCandidateIssuesResponse = z.infer<
  typeof listVndlyCandidateIssuesResponseSchema
>

export const listVndlyCandidateIssues = async (
  request: ListVndlyCandidateIssuesRequest
): Promise<ListVndlyCandidateIssuesResponse> => {
  const params = {
    page: request.page,
    page_size: request.pageSize,
    days_ago: request.daysAgo,
    instance_ids: request.instanceIds,
    company_ids: request.companyIds,
  }

  const response = await api.get<ListVndlyCandidateIssuesResponse>(
    '/admin/vndly/candidates_issues',
    { params, paramsSerializer: queryParamSerializer }
  )
  return listVndlyCandidateIssuesResponseSchema.parse(response.data)
}
